<template>
    <div>
        <el-col :span="span">
            <el-menu :default-active="activeMenu" class="el-menu-vertical-demo" background-color="#545c64"
                text-color="#fff" @open="handleOpen" @close="handleClose" active-text-color="#ffd04b"
                :collapse="isCollapse">
                <!-- 菜单滚动容器 -->
                <div style="height: 70vh;overflow-y: auto;scrollbar-width: none; -ms-overflow-style: none;">
                    <!-- 动态渲染菜单 -->
                    <template v-for="menu in menuList">
                        <!-- 子菜单 -->
                        <el-submenu v-if="menu.children && menu.children.length" :index="menu.index" :key="menu.index">
                            <template slot="title">
                                <i :class="menu.icon"></i>
                                <span>{{ menu.title }}</span>
                            </template>
                            <el-menu-item-group>
                                <template v-for="child in menu.children">
                                    <!-- 二级子菜单 -->
                                    <el-submenu v-if="child.children && child.children.length" :index="child.index"
                                        :key="child.index">
                                        <template slot="title">
                                            <span>{{ child.title }}</span>
                                        </template>
                                        <router-link :to="grandchild.path" v-for="grandchild in child.children"
                                            :key="grandchild.index">
                                            <el-menu-item :index="grandchild.index">
                                                <span slot="title">{{ grandchild.title }}</span>
                                            </el-menu-item>
                                        </router-link>
                                    </el-submenu>

                                    <!-- 普通菜单项 -->
                                    <router-link :to="child.path" v-else :key="child.index">
                                        <el-menu-item :index="child.index">
                                            <span slot="title">{{ child.title }}</span>
                                        </el-menu-item>
                                    </router-link>
                                </template>
                            </el-menu-item-group>
                        </el-submenu>

                        <!-- 普通菜单项 -->
                        <router-link :to="menu.path" v-else :key="menu.index">
                            <el-menu-item :index="menu.index">
                                <i :class="menu.icon"></i>
                                <span slot="title">{{ menu.title }}</span>
                            </el-menu-item>
                        </router-link>
                    </template>
                </div>

                <!-- 展开/收起按钮 -->
                <div style="position: fixed;bottom: 100px;left: 90px;">
                    <img v-if="isExpand" @click="Expand" src="../assets/retract.png" alt="收起">
                </div>
                <div style="position: fixed;bottom: 100px;left: 18px;">
                    <img v-if="isRetract" @click="Retract" src="../assets/expand.png" alt="展开">
                </div>

                <div v-if="isExpand" class="el-login-footer"
                    style="position: fixed;bottom: 50px;left: 2%;font-size: 12px;">
                    <!-- <span> @中研制业技术支持</span> -->
                    <span> @安徽环宝厨房设备制作有限公司</span>
                </div>
            </el-menu>
        </el-col>
    </div>
</template>

<script>
import { getMenuList } from '@/api/caidan';
import { mapState, mapGetters } from 'vuex';
// import Vue from 'vue'; // 引入Vue，用于事件总线

export default {
    data() {
        return {
            menuList: [],
            isCollapse: true,
            isRetract: true,
            isExpand: false,
            pathIndexMap: {},
            isFirstLoad: true
        };
    },
    computed: {
        ...mapState(['isLogin', 'userId']),
        ...mapGetters(['isAuthenticated']),
        // 计算列宽
        span() {
            return this.isCollapse ? 1 : 3;
        },
        // 激活菜单
        activeMenu() {
            const { path } = this.$route;
            return this.pathIndexMap[path] || '';
        }
    },
    watch: {
        // 监听登录状态：简化条件，登录成功就加载菜单
        isAuthenticated(newVal) {
            console.log('登录状态变化:', newVal);
            if (!this.isFirstLoad && newVal) {
                this.getMenuLists();
            }
        },
        // 监听userId：只要有值就加载菜单（无需依赖isLogin）
        userId(newVal) {
            if (newVal && !this.isFirstLoad) {
                this.getMenuLists();
            }
        },
        // 菜单数据变化时更新路径映射
        menuList(newVal) {
            if (newVal.length) {
                this.generatePathIndexMap();
            }
        }
    },
    mounted() {
        this.initAfterRefresh();
        // 监听登录成功后触发的菜单加载事件
        this.$bus.$on('loadMenu', () => {
            this.getMenuLists();
        });
    },
    beforeDestroy() {
        // 解绑事件，避免内存泄漏
        this.$bus.$off('loadMenu');
    },
    methods: {
        // 初始化：页面刷新后恢复状态
        initAfterRefresh() {
            const storedUserId = localStorage.getItem('userId');
            const currentPath = this.$route.path;
            this.isFirstLoad = false;

            if (storedUserId && currentPath !== '/') {
                this.getMenuLists();
            } else if (!storedUserId && currentPath !== '/') {
                this.$router.push('/');
            }
        },

        // 菜单请求：优先用Vuex的userId，备用localStorage
        async getMenuLists() {
            try {
                // 优先取Vuex的userId（确保状态同步），其次取本地缓存
                let userId = this.userId || localStorage.getItem('userId');
                if (!userId) {
                    console.error('用户ID不存在，无法请求菜单');
                    if (this.$route.path !== '/') {
                        this.$router.push('/');
                    }
                    return;
                }

                const response = await getMenuList({ userId });
                // 校验接口返回格式（避免slice后为空）
                if (response.data && Array.isArray(response.data)) {
                    // 过滤掉title为"功能间设备"的对象，保留其他所有数据
                    this.menuList = response.data.filter(item => item.title !== '功能间设备');
                    console.log('菜单数据加载成功(已过滤功能间设备):', this.menuList);
                } else {
                    this.$message.warning('未获取到菜单数据');
                    this.menuList = [];
                }
            } catch (error) {
                console.error('菜单请求失败:', error);
                this.$message.error('菜单加载失败，请重试');
                // 权限错误处理
                if (error.response?.status === 401 && this.$route.path !== '/') {
                    this.$store.dispatch('logout'); // 调用Vuex的退出方法，清理状态
                    this.$router.push('/');
                }
            }
        },

        // 生成路径-索引映射
        generatePathIndexMap() {
            const map = {};
            const traverse = (menuItems) => {
                menuItems.forEach(menu => {
                    if (menu.path) {
                        map[menu.path] = menu.index;
                    }
                    if (menu.children && menu.children.length) {
                        traverse(menu.children);
                    }
                });
            };
            traverse(this.menuList);
            this.pathIndexMap = map;
        },

        // 展开/收起菜单
        Retract() {
            this.isRetract = false;
            this.isExpand = true;
            this.updateCollapse();
        },
        Expand() {
            this.isRetract = true;
            this.isExpand = false;
            this.updateCollapse();
        },
        updateCollapse() {
            this.isCollapse = !this.isCollapse;
            this.$emit('update-collapse', this.isCollapse);
        },

        // 菜单展开/关闭事件
        handleOpen(key, keyPath) {
            console.log('菜单展开:', key, keyPath);
        },
        handleClose(key, keyPath) {
            console.log('菜单关闭:', key, keyPath);
        }
    }
};
</script>

<style scoped>
a {
    list-style: none;
    text-decoration: none;
}

.el-menu-item:hover {
    background-color: #000 !important;
    color: #fff !important;
}

.el-menu--collapse .el-submenu__title span {
    display: none;
}

.el-submenu__title {
    font-size: 16px !important;
    font-weight: 400 !important;
}

.el-dropdown-menu__item,
.el-menu-item {
    font-size: 15px !important;
}

::-webkit-scrollbar {
    display: none;
}
</style>
